/* ADISTIME · movimiento: aparición al hacer scroll, parallax suave y comparador antes/después */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.is-in), .mt-mask:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initParallax() {
    if (reduce) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-mt-parallax]'));
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        var amount = parseFloat(el.getAttribute('data-mt-parallax')) || 40;
        el.style.transform = 'translate3d(0,' + (p * -amount).toFixed(1) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initCompare(root) {
    (root || document).querySelectorAll('[data-mt-compare]').forEach(function (box) {
      if (box.__mtInit) return; box.__mtInit = true;
      var pos = 50, dir = 1, auto = !reduce, dragging = false, raf, started = false;
      var speed = parseFloat(box.getAttribute('data-mt-speed')) || 0.07;
      function set(p) {
        pos = Math.max(0, Math.min(100, p));
        box.style.setProperty('--mt-pos', pos + '%');
        var input = box.querySelector('input[type=range]'); if (input) input.value = pos;
      }
      function loop() {
        if (auto && !dragging) {
          pos += dir * speed * 16;
          if (pos >= 88) { pos = 88; dir = -1; }
          if (pos <= 12) { pos = 12; dir = 1; }
          set(pos);
        }
        raf = requestAnimationFrame(loop);
      }
      function fromEvent(e) {
        var r = box.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        set((x / r.width) * 100);
      }
      box.addEventListener('pointerdown', function (e) { dragging = true; auto = false; box.setPointerCapture && box.setPointerCapture(e.pointerId); fromEvent(e); });
      box.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
      ['pointerup', 'pointercancel'].forEach(function (n) { box.addEventListener(n, function () { dragging = false; }); });
      var input = box.querySelector('input[type=range]');
      if (input) input.addEventListener('input', function () { auto = false; set(parseFloat(input.value)); });
      set(50);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && !started) { started = true; loop(); }
          else if (!en[0].isIntersecting && started) { cancelAnimationFrame(raf); started = false; }
        }, { threshold: 0.3 }).observe(box);
      } else { loop(); }
    });
  }

  function boot() { initReveal(); initParallax(); initCompare(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Editor de temas: reaplicar al cargar o mover secciones
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initCompare(e.target); });
})();
